import {
  REVIEWS_ALL_REVIEWS_REQUEST,
  REVIEWS_ALL_REVIEWS_SUCCESS,
  REVIEWS_PRODUCT_REVIEWS_REQUEST,
  REVIEWS_PRODUCT_REVIEWS_SUCCESS,
  REVIEWS_PRODUCTS_STATS_REQUEST,
  REVIEWS_PRODUCTS_STATS_SUCCESS,
  REVIEWS_SITE_STATS_REQUEST,
  REVIEWS_SITE_STATS_SUCCESS,
} from '~/redux/actions/types'
import {
  getYotpoAllReviews,
  getYotpoProductReviews,
  getYotpoProductsBottomLines,
  getYotpoSiteBottomLine,
} from '~/services/yotpo/client'

export const fetchReviewsAllReviewsRequest = () => ({
  type: REVIEWS_ALL_REVIEWS_REQUEST,
})

export const fetchReviewsAllReviewsSuccess = (data) => ({
  type: REVIEWS_ALL_REVIEWS_SUCCESS,
  payload: {
    data,
  },
})

export const fetchReviewsProductReviewsRequest = (id) => ({
  type: REVIEWS_PRODUCT_REVIEWS_REQUEST,
  payload: {
    id,
  },
})

export const fetchReviewsProductReviewsSuccess = (id, data) => ({
  type: REVIEWS_PRODUCT_REVIEWS_SUCCESS,
  payload: {
    data,
    id,
  },
})

export const fetchReviewsProductsStatsRequest = () => ({
  type: REVIEWS_PRODUCTS_STATS_REQUEST,
})

export const fetchReviewsProductsStatsSuccess = (data) => ({
  type: REVIEWS_PRODUCTS_STATS_SUCCESS,
  payload: {
    data,
  },
})

export const fetchReviewsSiteStatsRequest = () => ({
  type: REVIEWS_SITE_STATS_REQUEST,
})

export const fetchReviewsSiteStatsSuccess = (data) => ({
  type: REVIEWS_SITE_STATS_SUCCESS,
  payload: {
    data,
  },
})

export const fetchAllReviews =
  () =>
  async (dispatch, getState, { chord }) => {
    if (getState().reviews.reviews?.fetched.includes('all')) return

    dispatch(fetchReviewsAllReviewsRequest())

    return getYotpoAllReviews()
      .then((data) => dispatch(fetchReviewsAllReviewsSuccess(data)))
      .catch((error) => {})
  }

export const fetchProductReviews =
  (id) =>
  async (dispatch, getState, { chord }) => {
    if (getState().reviews.reviews?.fetched.includes(id)) return

    dispatch(fetchReviewsProductReviewsRequest(id))

    return getYotpoProductReviews(id)
      .then((data) => dispatch(fetchReviewsProductReviewsSuccess(id, data)))
      .catch((error) => {})
  }

export const fetchReviewsProductsStats =
  () =>
  async (dispatch, getState, { chord }) => {
    if (getState().reviews.stats.products.hasFetched) return

    dispatch(fetchReviewsProductsStatsRequest())

    getYotpoProductsBottomLines()
      .then((data) => dispatch(fetchReviewsProductsStatsSuccess({ data })))
      // No error action because they're not mission critical.
      .catch((error) => {})
  }

export const fetchReviewsSiteStats =
  () =>
  async (dispatch, getState, { chord }) => {
    if (getState().reviews.stats.site.hasFetched) return

    dispatch(fetchReviewsSiteStatsRequest())

    getYotpoSiteBottomLine()
      .then((data) => dispatch(fetchReviewsSiteStatsSuccess({ data })))
      // No error action because they're not mission critical.
      .catch((error) => {})
  }
